import axios from "./../../config/axios"

export function accountSummary(query) {
    return axios().get(`/purchase/supplier-accounts/list`, { params: query });
}

export function printAccountSummary(query) {
    return axios().get(`/purchase/supplier-accounts/list`, {
                    params: query,
                    headers: {
                        "Accept": 'text/html'
                    }
                });
}

export function getOrdersFulfillment() {
    return axios().get(`/purchase/purchase-orders-fullfillment`);
}

export function getOrdersCompletion() {
    return axios().get(`/purchase/purchase-orders-completion`);
}

export function getPurchaseSummary(query) {
    return axios().get(`/purchase/purchase-summary`, { params: query});
}

export function printPuchaseSummary(query) {
    return axios().get(`/purchase/purchase-summary`, {
        params: query,
        headers: {
            "Accept": 'text/html'
        }
    });
}

export default {
    accountSummary,
    getOrdersFulfillment,
    getOrdersCompletion,
    getPurchaseSummary,
}